module.exports = __webpack_public_path__ + "img/text.e45373db.png";